import { render, staticRenderFns } from "./ExtraPacsList.vue?vue&type=template&id=6569e07c"
import script from "./ExtraPacsList.vue?vue&type=script&lang=js"
export * from "./ExtraPacsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports